<template>
  <div id="homepage">
    <Navbar />
    <Iklan />
    <!-- <Sponsor/> -->
    <Benefit />
    <Work />
    <Footer />
    <ModalLogin />
    <ModalRegister />
    <Fab />
  </div>
</template>
<script>
import Navbar from "../components/Navbar";
import Iklan from "../components/Iklan";
import Fab from "../components/Fab";
// import Sponsor from '../components/Sponsor';
import Benefit from "../components/Benefit";
import Work from "../components/Work";
import Footer from "../components/Footer";

import ModalLogin from "../components/modal/ModalLogin";
import ModalRegister from "../components/modal/ModalRegister";

export default {
  name: "Homepage",
  metaInfo() {
    return { 
      title: "Zonasea - Platform Perkapalan Terpercaya di Indonesia",
      meta: [
        { name: 'description', content:  'Menghubungkan langsung pemilik kapal tug boat, tongkang, tanker, bulk carrier dengan pemilik muatan sawit, batu bara, nikel, solar dan lainnya.'}
      ]
    }
  },
  components: {
    Navbar,
    ModalLogin,
    ModalRegister,
    Iklan,
    // Sponsor,
    Benefit,
    Work,
    Footer,
    Fab
  },
  created() {
    // const title = "Zonasea";
    // document.title = title;
  },
  data() {
    return {
      msg: " hellow",
    };
  },
};
</script>
